module.exports = __webpack_public_path__ + "static/traffic-8af6b3ca8a87b48525a4f7997dc52156.jpg";